class ClientModel{
    constructor(){
        this.id = null;
        this.name = null;
        this.phone = null;
    }
}

export default ClientModel;